import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

interface Props {
  flag: string;
  fallbackPath?: string;
  children: React.ReactNode;
}

export function FeatureGate({ flag, fallbackPath = '/', children }: Props) {
  const { enabled, loading } = useFeatureFlag(flag);

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
